import { InvitationRequest } from '../request-models/invitation-request.model';
import { omitUndefined } from './wire-value-utils';

/** The hub request body for creating an invitation: only the allowlisted fields that are set. */
export function toInvitationRequest(fields: InvitationRequest): InvitationRequest {
  return omitUndefined<InvitationRequest>({
    email: fields.email,
    firstName: fields.firstName,
    lastName: fields.lastName,
    role: fields.role,
  });
}
